module.exports = __webpack_public_path__ + "static/media/bi_emblem_white_m.7779a877.png";